import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/freq/adv/adv_0001.webp")